import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import React from 'react';
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import {List, ListItem, ListItemIcon, ListItemText, SvgIcon, Link} from "@material-ui/core";
import PhoneIcon from "@material-ui/icons/Phone";
import {QueryResult, State} from '../App';
import FaceIcon from '@material-ui/icons/Face';
import DoneIcon from '@material-ui/icons/Done';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import EmailIcon from '@material-ui/icons/Email';
import BusinessIcon from '@material-ui/icons/Business';
import VpnKeyIcon from '@material-ui/icons/VpnKey';

interface ResultProps {
    state: State;
    closeResult: () => void;
    result: QueryResult;
}

function Result(props: ResultProps) {
    return (
        <React.Fragment>
            {
                props.state === State.Succeeded &&
                <Paper>
                    <Box pt={2} px={2} pb={1}>
                        <Box display="flex" flexDirection="row" justifyContent="center">
                            <Box flexGrow={1}>
                                <Typography component="h5" variant="h5">检测结果</Typography>
                            </Box>
                            <IconButton size="small">
                                <CloseIcon onClick={() => {
                                    props.closeResult();
                                }}/>
                            </IconButton>
                        </Box>
                        <Box mt={1}>
                            <List disablePadding component="nav" aria-label="main mailbox folders">
                                {
                                    (
                                        props.result.names.length === 0 &&
                                        props.result.nicknames.length === 0 &&
                                        props.result.phone_numbers.length === 0 &&
                                        props.result.id_numbers.length === 0 &&
                                        props.result.qq_numbers.length === 0 &&
                                        props.result.wb_numbers.length === 0 &&
                                        props.result.passwords.length === 0 &&
                                        props.result.emails.length === 0 &&
                                        props.result.addresses.length === 0
                                    ) && <ListItem disableGutters>
                                        <ListItem>
                                            <ListItemIcon>
                                                <DoneIcon/>
                                            </ListItemIcon>
                                            <ListItemText primary="暂未查询到任何结果"/>
                                        </ListItem>
                                    </ListItem>
                                }
                                {
                                    props.result.names.map((name, index) =>
                                        <ListItem disableGutters key={index}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <FaceIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={name}/>
                                            </ListItem>
                                        </ListItem>
                                    )
                                }
                                {
                                    props.result.nicknames.map((nickname, index) =>
                                        <ListItem disableGutters key={index}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <AccountCircleIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={nickname}/>
                                            </ListItem>
                                        </ListItem>
                                    )
                                }
                                {
                                    props.result.phone_numbers.map((phoneNumber, index) =>
                                        <ListItem disableGutters key={index}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <PhoneIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={phoneNumber}/>
                                            </ListItem>
                                        </ListItem>
                                    )
                                }
                                {
                                    props.result.id_numbers.map((idNumber, index) =>
                                        <ListItem disableGutters key={index}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <SvgIcon>
                                                        <path fill="currentColor"
                                                              d="M2,3H22C23.05,3 24,3.95 24,5V19C24,20.05 23.05,21 22,21H2C0.95,21 0,20.05 0,19V5C0,3.95 0.95,3 2,3M14,6V7H22V6H14M14,8V9H21.5L22,9V8H14M14,10V11H21V10H14M8,13.91C6,13.91 2,15 2,17V18H14V17C14,15 10,13.91 8,13.91M8,6A3,3 0 0,0 5,9A3,3 0 0,0 8,12A3,3 0 0,0 11,9A3,3 0 0,0 8,6Z"/>
                                                    </SvgIcon>
                                                </ListItemIcon>
                                                <ListItemText primary={idNumber}/>
                                            </ListItem>
                                        </ListItem>
                                    )
                                }
                                {
                                    props.result.qq_numbers.map((qqNumber, index) =>
                                        <ListItem disableGutters key={index}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <SvgIcon>
                                                        <path fill="currentColor"
                                                              d="M3.18,13.54C3.76,12.16 4.57,11.14 5.17,10.92C5.16,10.12 5.31,9.62 5.56,9.22C5.56,9.19 5.5,8.86 5.72,8.45C5.87,4.85 8.21,2 12,2C15.79,2 18.13,4.85 18.28,8.45C18.5,8.86 18.44,9.19 18.44,9.22C18.69,9.62 18.84,10.12 18.83,10.92C19.43,11.14 20.24,12.16 20.82,13.55C21.57,15.31 21.69,17 21.09,17.3C20.68,17.5 20.03,17 19.42,16.12C19.18,17.1 18.58,18 17.73,18.71C18.63,19.04 19.21,19.58 19.21,20.19C19.21,21.19 17.63,22 15.69,22C13.93,22 12.5,21.34 12.21,20.5H11.79C11.5,21.34 10.07,22 8.31,22C6.37,22 4.79,21.19 4.79,20.19C4.79,19.58 5.37,19.04 6.27,18.71C5.42,18 4.82,17.1 4.58,16.12C3.97,17 3.32,17.5 2.91,17.3C2.31,17 2.43,15.31 3.18,13.54Z"/>
                                                    </SvgIcon>
                                                </ListItemIcon>
                                                <ListItemText primary={qqNumber}/>
                                            </ListItem>
                                        </ListItem>
                                    )
                                }
                                {
                                    props.result.wb_numbers.map((wbNumber, index) =>
                                        <ListItem disableGutters key={index}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <SvgIcon viewBox="0 0 512 512">
                                                        <path fill="currentColor"
                                                              d="M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"/>
                                                    </SvgIcon>
                                                </ListItemIcon>
                                                <Link color="secondary" href={"https://m.weibo.cn/u/"+wbNumber.split('%:|:%')[0]} target="_blank">{wbNumber.split('%:|:%')[1]}</Link>
                                            </ListItem>
                                        </ListItem>
                                    )
                                }
                                {
                                    props.result.passwords.map((qqNumber, index) =>
                                        <ListItem disableGutters key={index}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <VpnKeyIcon/>
                                                </ListItemIcon>
                                                <ListItemText primaryTypographyProps={{style: {wordWrap: "break-word"}}}
                                                              primary={qqNumber}/>
                                            </ListItem>
                                        </ListItem>
                                    )
                                }
                                {
                                    props.result.emails.map((email, index) =>
                                        <ListItem disableGutters key={index}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <EmailIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={email}/>
                                            </ListItem>
                                        </ListItem>
                                    )
                                }
                                {
                                    props.result.addresses.map((address, index) =>
                                        <ListItem disableGutters key={index}>
                                            <ListItem>
                                                <ListItemIcon>
                                                    <BusinessIcon/>
                                                </ListItemIcon>
                                                <ListItemText primary={address}/>
                                            </ListItem>
                                        </ListItem>
                                    )
                                }
                            </List>
                        </Box>
                    </Box>
                </Paper>
            }
        </React.Fragment>
    );
}

export default Result;
